const actions = {
    FETCH_SALARY_DECLARATIONS: 'FETCH_SALARY_DECLARATIONS',
    FETCH_SALARY_DECLARATION: 'FETCH_SALARY_DECLARATION',
    FETCH_USER_MONTHLY_ATTENDANCE: 'FETCH_USER_MONTHLY_ATTENDANCE',
    RESET_SALARY_DECLARATION: 'RESET_SALARY_DECLARATION',
    RESET_USER_MONTHLY_ATTENDANCE: 'RESET_USER_MONTHLY_ATTENDANCE',
    SINGLE_USER: 'SINGLE_USER',

    fetchSalaryDeclarationsAction: (data) => {
        return {
            type: actions.FETCH_SALARY_DECLARATIONS,
            data: data
        };
    },
    resetSalaryDeclarationFormAction: () => {
        return {
            type: actions.RESET_SALARY_DECLARATION,
            data: null
        };
    },
    resetUserMonthlyAttendanceAction: () => {
        return {
            type: actions.RESET_USER_MONTHLY_ATTENDANCE,
            data: []
        };
    },
    fetchSalaryDeclarationAction: (data) => {
        return {
            type: actions.FETCH_SALARY_DECLARATION,
            data: data
        };
    },
    fetchUserMonthlyAttendanceAction: (data) => {
        return {
            type: actions.FETCH_USER_MONTHLY_ATTENDANCE,
            data: data
        };
    },
    singleUserAction: (data) => {
        return {
            type: actions.SINGLE_USER,
            data: data
        };
    },
};

export default actions;
